import { Pipe, PipeTransform } from '@angular/core';
import { I18nTranslator } from '../i18n/translate';
import { ARConsoleVersion } from '../models/agrorendement-common-lists.model';

@Pipe({
  name: 'consoleVersionFilter',
  standalone: true,
})
export class ConsoleVersionFilterPipe implements PipeTransform {
  constructor(private i18nTranslator: I18nTranslator) {}

  transform(consoleVersions: ARConsoleVersion[], args: any): any {
    if (!consoleVersions) {
      consoleVersions = [];
    }

    const consoleTypeId = +args;
    const filtered = consoleVersions.filter((consoleVersion) => consoleVersion.consoleType.id === consoleTypeId);

    for (let i = 0; i < filtered.length; i++) {
      const consoleVersion = filtered[i];
      if (consoleVersion.code === 'OTHER') {
        // TODO faire distinction Autre/Toutes comme variety ?
        // TODO effet de bord : OK ?
        consoleVersion.label = this.i18nTranslator.translate('ar.edit.vra.console.version.other');
        // TODO en premier ?
        if (i !== 0) {
          filtered.splice(i, 1);
          filtered.unshift(consoleVersion);
        }
        break;
      }
    }

    return filtered;
  }
}
